import { Icon } from "@iconify/react";
import { useState } from "react";
import bg_brain from "../../assets/images/bg_brain.png";
import bg_brain_mobile from "../../assets/images/bg_brain_mobile.png";
import useIsMobile from "../../utils/useIsMobile";
import AuthDialog from "../auth/AuthDialog";
import { HealthyLife, StartFreeTrail } from "./LandingPage";

export default function ScienceBehindPage() {
  const [showAuth, setShowAuth] = useState(false);
  const isMobile = useIsMobile();

  return (
    <div className="w-full h-full">
      <AuthDialog open={showAuth} setOpen={setShowAuth} />
      <div
        style={{
          backgroundImage: `url(${isMobile ? bg_brain_mobile : bg_brain})`,
        }}
        className=" w-full h-screen snap-mandatory bg-center bg-no-repeat bg-cover snap-y overflow-auto no-scrollbar"
      >
        <div className="relative snap-mandatory">
          <div className="snap-start h-screen flex flex-col py-20 bg-primary-midBlack bg-opacity-50">
            <a href="/">
              <p className="text-white font-bold flex flex-row items-center gap-1 px-5 md:px-32 fixed">
                <span>
                  <Icon
                    icon="ic:baseline-arrow-right-alt"
                    className="rotate-180"
                  />
                </span>
                Go back to the home page
              </p>
            </a>
            <div className="h-full flex flex-col justify-center items-center">
              <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug text-center ">
                <span className="text-primary-neonGreen">Science</span> behind
                <br></br>
                every move
              </p>
              <p className="font-open-sans mt-2 text-center text-white text-opacity-70 font-medium text-lg md:text-xl">
                An amalgamation of computer science, physiological and human
                science
              </p>
            </div>
          </div>

          <div
            className="snap-start md:h-screen bg-[#373360] px-5 md:px-32 py-20 bg-opacity-70 "
            id="computer-science"
          >
            <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
              <span className="text-primary-neonGreen">Computer</span>
              <br></br>
              science
            </p>
            <div className="flex flex-col md:flex-row gap-10 mt-10">
              <p className="flex flex-1 text-white text-opacity-80 font-open-sans leading-8">
                Once a user begins his/her recommended workout, the Computer
                Vision which is at the core of getactyv enables the estimation
                of the human body’s joint locations on the cartesian plane (X,
                Y) from the frames. These frames are split from the user’s
                accessed video feed and passed through a neural network.
                <br />
                <br /> Our motion-tracking engine analyzes these joint locations
                and angles between each joint to check the user's movement
                throughout the workout cycle. Based on this data, it gives
                real-time feedback to the user about the posture and corrects
                him/ her to perform a particular exercise correctly.
              </p>
              <p className="flex flex-1 text-white text-opacity-80 font-open-sans  leading-8">
                The machine learning engine enables getactyv to perform
                automatic rep counting of various exercises that the user is
                performing in front of the screen. It helps the user in focusing
                on his exercise and not to worry about tracking it by
                themselves.
              </p>
            </div>
          </div>
          <div
            className="snap-start md:h-screen bg-[#336055] bg-opacity-70 px-5 md:px-32 py-20 "
            id="physiological-science"
          >
            <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
              <span className="text-primary-neonGreen">Physiological</span>
              <br></br>
              science
            </p>
            <div className="flex flex-col md:flex-row gap-10 mt-10">
              <p className="flex flex-1 flex-col text-white text-opacity-80 font-open-sans leading-8">
                <span className="font-bold">
                  (aided by a Recommendation Engine)
                </span>
                <br /> Everybody is unique in their appearance. Having a
                one-size-fits-all approach might not work for everyone because
                everyone is special in their own way. Hence, we built a
                hyper-customised program from our proprietary Recommendation
                Engine.
                <br />
                <br />
                <span className="font-bold">How does it work?</span>
                Every user is assessed for strength, stamina, and fitness level,
                and based on the assessment, programs are designed with our
                Recommendation Engine. When the process is completed, it
                produces a physical response which is captured by our
                performance metrics.
              </p>
              <p className="flex flex-1 flex-col text-white text-opacity-80 font-open-sans  leading-8">
                <span className="font-bold">Why is it important?</span> These
                metrics serve as a pointer to the underlying physiological
                aspects concerning the skeletal, cardiovascular, and
                neurological systems, indicating specific markers for each of
                these systems. These biological markers give a holistic
                dimension toward better health and wellness.
                <br />
                <br />
                <span className="font-bold">How does it help?</span> Through
                getactyv’s proprietary Recommendation Engine, personalised plans
                are generated which simulate the intelligence of an
                Olympic-level trainer allowing the users to march towards their
                chosen goals.
              </p>
            </div>
          </div>

          <div
            className="snap-start md:h-screen bg-[#605B33] bg-opacity-70 px-5 md:px-32 py-20 "
            id="human-science"
          >
            <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
              <span className="text-primary-neonGreen">Human</span>
              <br></br>
              science
            </p>
            <div className="flex flex-col md:flex-row gap-10 mt-10">
              <p className="flex flex-1 text-white text-opacity-80 font-open-sans leading-8">
                Exercise can reverse the biological process of aging. Our
                personalised and carefully curated workout programs help you in
                having a healthy and fitter life. Leading a healthy lifestyle
                not only provides an abundance of energy for everyday chores,
                but also helps in mental alertness and boosts immunity.
              </p>
              <p className="flex flex-1 text-white text-opacity-80 font-open-sans  leading-8"></p>
            </div>
          </div>

          <div className="hidden md:flex sticky flex-row w-full bottom-0 ">
            <p
              className="flex flex-1 cursor-pointer px-10  border-r-[1px] border-primary-lightGray  items-center font-poppins  bg-primary-midBlack bg-opacity-80 py-6 text-white font-bold text-xl 3xl:text-3xl underline"
              onClick={() => {
                document.getElementById("computer-science").scrollIntoView({
                  behavior: "smooth",
                });
              }}
            >
              Computer Science
              <Icon
                icon="material-symbols:arrow-right-alt-rounded"
                className="text-white"
                inline={true}
              />
            </p>
            <p
              className="flex flex-1 cursor-pointer  border-r-[1px] border-primary-lightGray  items-center font-poppins px-10 bg-primary-midBlack bg-opacity-80 py-2  text-white font-bold text-xl 3xl:text-3xl underline"
              onClick={() => {
                document
                  .getElementById("physiological-science")
                  .scrollIntoView({
                    behavior: "smooth",
                  });
              }}
            >
              Physiological Science
              <Icon
                icon="material-symbols:arrow-right-alt-rounded"
                className="text-white"
                inline={true}
              />
            </p>
            <p
              className="flex flex-1 cursor-pointer px-10 items-center font-poppins  bg-primary-midBlack bg-opacity-80 py-2 text-white font-bold text-xl 3xl:text-3xl underline"
              onClick={() => {
                document.getElementById("human-science").scrollIntoView({
                  behavior: "smooth",
                });
              }}
            >
              Human Science
              <Icon
                icon="material-symbols:arrow-right-alt-rounded"
                className="text-white"
                inline={true}
              />
            </p>
            {/* <div
              className="flex px-20 cursor-pointer justify-center items-center font-poppins bg-primary-purple bg-opacity-30 py-3  text-white font-bold text-xl 3xl:text-3xl underline"
              onClick={() => {
                document.getElementById("computer-science").scrollIntoView({
                  behavior: "smooth",
                });
              }}
            >
              <Icon
                icon="material-symbols:arrow-back-ios-new"
                className="text-white -rotate-90 border-2 border-white rounded-full w-10 h-10  p-2"
              />
            </div> */}
          </div>
        </div>
        <div className="snap-start bg-primary-midBlack">
          <HealthyLife
            openAuth={() => {
              setShowAuth(true);
            }}
          />
          <StartFreeTrail
            openAuth={() => {
              setShowAuth(true);
            }}
          />
        </div>
      </div>
    </div>
  );
}
